import { parseISO } from 'date-fns';
import { Mapper } from '../../../mappers';
import { PersonalAccessToken, PersonalAccessTokenItem } from '../../../models';
import { ValueAndDisplay } from '../models';
import { PersonalAccessToken as OctopusPersonalAccessToken } from '../models/personal-access-token';

export class PersonalAccessTokenMapper extends Mapper<
  OctopusPersonalAccessToken[],
  PersonalAccessToken
> {
  from(source: OctopusPersonalAccessToken[]): PersonalAccessToken {
    const items = source.map((item) => {
      return this.mapItem(item);
    });
    return new PersonalAccessToken(...items);
  }

  mapItem(source: OctopusPersonalAccessToken): PersonalAccessTokenItem {
    return {
      key: source.Key ?? '',
      name: source.Name,
      database: source.Database,
      expirationDate: parseISO(source.ExpirationDate),
      revokeDate: source.RevokeDate ? parseISO(source.RevokeDate) : undefined,
      status: source.Status as ValueAndDisplay<number>,
    };
  }
}
